import { __read, __spreadArray } from "tslib";
import React, { useContext, useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { View } from "../_core/components";
import { CollapseContext } from "./CollapseContext";
import { Icon } from "../icon";
import { injectValue } from "../_util/inject-value";
import { getRect } from "../_util/get-rect";
import { useIsReady } from "../_util/use-is-ready";
import { useConfig } from "../_util/use-config";
export function CollapsePanel(_a) {
    var id = _a.id, title = _a.title, extra = _a.extra, children = _a.children, className = _a.className, style = _a.style;
    var classPrefix = useConfig().classPrefix;
    var ref = useRef(null);
    var _b = __read(useState(0), 2), height = _b[0], setHeight = _b[1];
    var _c = useContext(CollapseContext), activeIds = _c.activeIds, onActive = _c.onActive;
    var active = activeIds.includes(id);
    var isReady = useIsReady();
    useEffect(function () {
        if (!isReady) {
            return;
        }
        if (active) {
            getRect(ref).then(function (_a) {
                var _b = __read(_a, 1), height = _b[0].height;
                setHeight(height);
            });
        }
        else {
            setHeight(0);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active]);
    // 首次渲染立即获取高度有差异
    useEffect(function () {
        if (isReady && active) {
            setTimeout(function () {
                getRect(ref).then(function (_a) {
                    var _b = __read(_a, 1), height = _b[0].height;
                    setHeight(height);
                });
            }, 100);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isReady, children]);
    function handleClick(event) {
        if (active) {
            onActive(activeIds.filter(function (activeId) { return activeId !== id; }), { event: event, activeId: id, active: !active });
        }
        else {
            onActive(__spreadArray(__spreadArray([], __read(activeIds)), [id]), { event: event, activeId: id, active: !active });
        }
    }
    return (React.createElement(View, { className: classNames(classPrefix + "-collapse-panel", classPrefix + "-hairline--top", className, {
            "is-active": active,
        }), style: style },
        React.createElement(View, { className: classPrefix + "-collapse-panel__header", onClick: handleClick },
            React.createElement(View, { className: classPrefix + "-collapse-panel__title " + classPrefix + "-ellipsis" }, injectValue(title)(active)),
            React.createElement(View, { className: classPrefix + "-collapse-panel__extra" }, injectValue(extra)(active)),
            React.createElement(Icon, { className: classPrefix + "-collapse-panel__arrow", name: "chevrondown" })),
        React.createElement(View, { className: classPrefix + "-collapse-panel__wrap " + classPrefix + "-hairline--top", style: { height: height + "px" } },
            React.createElement(View, { className: classPrefix + "-collapse-panel__content", ref: ref }, children))));
}
//# sourceMappingURL=CollapsePanel.js.map